
import * as React from 'react';
import {
    List,
    Datagrid,
    Filter,
    TextField,
    BooleanField,

    TextInput,
    BooleanInput,
    NumberInput,
    SimpleForm,
    Edit,
    Create,
    EditButton,
    DeleteWithConfirmButton,
    useRedirect,
    TopToolbar,
    Button,
    DateField,

} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import { ArrowBack, Search } from '@material-ui/icons';
import { Box, Button as CButton } from '@material-ui/core';
import { Form } from 'react-final-form';
import { UpLoadFile, FirstImageField } from '../components/custom/UpLoadFile';

const useStyles = makeStyles({
    imageField: {
        '& img': { width: 60 }
    },
});

const useTxtData = {
    page: {
        tableName: '政务资料',
    },
    table: {
        id: 'ID',
        Title: '标题',
        Description: '描述',
        Attachments: '附件',
        Category: '分类',
        OrderNum: '排序',
        Open: '是否发布',
        CreateTime: '创建时间',
    }
};

const GovServiceManualFilters = (props) => {
    return (
        <Filter {...props}>
            <TextInput label="标题/描述/分类" source="key" resettable alwaysOn />
        </Filter>
    );
};

export const GovServiceManualList = (props) => {
    const classes = useStyles();
    return (
        <List {...props} title={useTxtData.page.tableName + '列表'} sort={{ field: 'id', order: 'DESC' }} filters={<GovServiceManualFilters />} >
            <Datagrid>
                <TextField label={useTxtData.table.id} source="id" />
                <FirstImageField label={useTxtData.table.Attachments} source="Attachments" picResize className={classes.imageField} />
                <TextField label={useTxtData.table.Title} source="Title" />
                <TextField label={useTxtData.table.Category} source="Category" />
                <TextField label={useTxtData.table.OrderNum} source="OrderNum" />
                <BooleanField label={useTxtData.table.Open} source="Open" />
                <DateField label={useTxtData.table.CreateTime} source="CreateTime" />
                <EditButton />
                <DeleteWithConfirmButton confirmTitle="删除确认" confirmContent="确认要删除该资料吗？" />
            </Datagrid>
        </List>
    );
};

export const GovServiceManualEdit = (props) => {
    const redirect = useRedirect();
    const Actions = (props) => (
        <TopToolbar>
            <Button label="返回列表" onClick={() => redirect(props.basePath)} variant="text">
                <ArrowBack />
            </Button>
        </TopToolbar>
    );

    return (
        <Edit title={'编辑' + useTxtData.page.tableName} {...props} actions={<Actions />}>
            <SimpleForm>
                <TextInput label={useTxtData.table.Title} source="Title" fullWidth />
                <TextInput label={useTxtData.table.Category} source="Category" />
                <TextInput label={useTxtData.table.Description} source="Description" multiline fullWidth />
                <UpLoadFile multiple label={useTxtData.table.Attachments} source="Attachments" />
                <NumberInput label={useTxtData.table.OrderNum} source="OrderNum" defaultValue={0} />
                <BooleanInput label={useTxtData.table.Open} source="Open" defaultValue={true} />
            </SimpleForm>
        </Edit>
    );
};

export const GovServiceManualCreate = (props) => {
    const redirect = useRedirect();
    const Actions = (props) => (
        <TopToolbar>
            <Button label="返回列表" onClick={() => redirect(props.basePath)} variant="text">
                <ArrowBack />
            </Button>
        </TopToolbar>
    );

    return (
        <Create title={'新增' + useTxtData.page.tableName} {...props} actions={<Actions />}>
            <SimpleForm redirect="list">
                <TextInput label={useTxtData.table.Title} source="Title" fullWidth />
                <TextInput label={useTxtData.table.Category} source="Category" />
                <TextInput label={useTxtData.table.Description} source="Description" multiline fullWidth />
                <UpLoadFile multiple label={useTxtData.table.Attachments} source="Attachments" />
                <NumberInput label={useTxtData.table.OrderNum} source="OrderNum" defaultValue={0} />
                <BooleanInput label={useTxtData.table.Open} source="Open" defaultValue={true} />
            </SimpleForm>
        </Create>
    );
};
